import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TimetableSlotResponseDto } from "../../shared/dtos/timetableSlot/TimetableSlotResponseDto";
import { PaginationDto } from "../../shared/dtos/common/PaginationDto";
import { ServerStatusPayload } from "../../shared/interfaces/ServerStatusPayload";

export interface TimetableSlotState {
  loadingTimetableSlots: boolean;
  loadingTimetableSlot: boolean;
  loadingTimetableSlotUpdate: boolean;

  errorLoadingTimetableSlots: string | null;
  errorLoadingTimetableSlot: string | null;
  errorUpdatingTimetableSlot: string | null;

  timetableSlots: TimetableSlotResponseDto[];
  timetableSlot: TimetableSlotResponseDto | null;

  serverStatus: ServerStatusPayload | null;
  pagination: PaginationDto | null;
}

const initialState: TimetableSlotState = {
  loadingTimetableSlots: false,
  loadingTimetableSlot: false,
  loadingTimetableSlotUpdate: false,

  errorLoadingTimetableSlots: null,
  errorLoadingTimetableSlot: null,
  errorUpdatingTimetableSlot: null,

  timetableSlots: [],
  timetableSlot: null,

  serverStatus: null,
  pagination: null,
};

export const timetableSlotSlice = createSlice({
  name: "timetableSlot",
  initialState,
  reducers: {
    setLoadingTimetableSlots(state) {
      state.loadingTimetableSlots = true;
      state.errorLoadingTimetableSlots = null;
    },
    setLoadingTimetableSlot(state) {
      state.loadingTimetableSlot = true;
      state.errorLoadingTimetableSlot = null;
    },
    setLoadingTimetableSlotUpdate(state) {
      state.loadingTimetableSlotUpdate = true;
      state.errorUpdatingTimetableSlot = null;
    },

    setErrorLoadingTimetableSlots(state, action: PayloadAction<string | null>) {
      state.loadingTimetableSlots = false;
      state.errorLoadingTimetableSlots = action.payload;
    },
    setErrorLoadingTimetableSlot(state, action: PayloadAction<string | null>) {
      state.loadingTimetableSlot = false;
      state.errorLoadingTimetableSlot = action.payload;
    },
    setErrorUpdatingTimetableSlot(state, action: PayloadAction<string | null>) {
      state.loadingTimetableSlotUpdate = false;
      state.errorUpdatingTimetableSlot = action.payload;
    },

    setTimetableSlots(
      state,
      action: PayloadAction<TimetableSlotResponseDto[]>,
    ) {
      state.loadingTimetableSlots = false;
      state.errorLoadingTimetableSlots = null;
      state.timetableSlots = action.payload;
    },
    setTimetableSlot(state, action: PayloadAction<TimetableSlotResponseDto>) {
      state.loadingTimetableSlot = false;
      state.errorLoadingTimetableSlot = null;
      state.timetableSlot = action.payload;
    },

    updateTimetableSlotSuccess(
      state,
      action: PayloadAction<TimetableSlotResponseDto>,
    ) {
      state.timetableSlots = state.timetableSlots.map((b) =>
        b.id === action.payload.id ? action.payload : b,
      );
      if (state.timetableSlot && state.timetableSlot.id === action.payload.id) {
        state.timetableSlot = action.payload;
      }
      state.loadingTimetableSlotUpdate = false;
      state.errorUpdatingTimetableSlot = null;
    },

    setServerResponseStatus(
      state,
      action: PayloadAction<ServerStatusPayload | null>,
    ) {
      state.serverStatus = action.payload;
    },
    setPagination(state, action: PayloadAction<PaginationDto>) {
      state.pagination = action.payload;
    },
  },
});

export const timetableSlotActions = timetableSlotSlice.actions;
export default timetableSlotSlice.reducer;
